export default "__VITE_ASSET__BfZejdX$__"